import React from 'react';
import { Typography, Grid } from '@mui/material';
import { BlueButton } from '../../atoms';
import { Quiz } from '../../types';
import { BASE_URL } from '../../config';
export interface QuizEndProps {
  quiz: Quiz;
}

export const QuizEnd = (props: QuizEndProps) => {
  return (
    <>
      <Grid
        container
        justifyContent="center"
        sx={{ my: 8, px: { xs: 2, sm: 20 } }}
      >
        <Typography component="p">
          {props.quiz.end_message ||
            `Thank you for including Rootine in your health stack. Your survey results will help us make your Rootine even better`}
        </Typography>
      </Grid>

      <Grid container justifyContent="center" sx={{ mt: 2 }}>
        <BlueButton
          label={props.quiz.end_button_text || 'Back to dashboard'}
          href={props.quiz.end_link || `${BASE_URL}/dashboard`}
        />
      </Grid>
    </>
  );
};
